import { NumericField } from './NumericField';

export type { NumericFieldProps } from './NumericFieldProps';
export { NumericField };
export default NumericField;
